import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import { makeStyles, Theme } from '@material-ui/core';

export const EmptyCell = withStyles(() => ({
  root: {
    border: '0',
  },
}))(TableCell);

export const DefaultTableCell = withStyles(theme => ({
  root: {
    textAlign: 'center',
    borderColor: theme.palette.grey['500'],
    borderStyle: 'solid',
    borderWidth: '0 0.2px 0.2px 0.2px',
    width: '10px',
    padding: '2px',
    color: 'inherit',
    fontWeight: 300,
  },
}))(TableCell);

export const RowTitleCell = withStyles(() => ({
  root: {
    borderLeftWidth: 0,
  },
}))(DefaultTableCell);

export const TotalTableCell = withStyles(() => ({
  root: {
    fontWeight: 800,
    topBorderWidth: 0,
  },
}))(DefaultTableCell);

export const BottomRowCell = withStyles(theme => ({
  root: {
    border: 0,
    paddingTop: theme.spacing(1),
  },
}))(TotalTableCell);

interface StyleProps {
  isCompact: boolean;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) => ({
  container: {
    display: 'flex',
    margin: `${theme.spacing(2)}px 0`,
    borderBottom: '0px',
    backgroundColor: theme.palette.grey['100'],
  },
  productRow: ({ isCompact }) => ({
    display: 'flex',
    flexDirection: isCompact ? 'column' : 'row',
    width: '100%',
  }),
  productLabelContainer: ({ isCompact }) => ({
    display: 'flex',
    alignSelf: 'center',
    padding: isCompact ? theme.spacing(1) : `${theme.spacing(1)}px ${theme.spacing(3)}px`,
    width: isCompact ? '100%' : '50%',
  }),
  compactQuantityFieldContainer: { width: '20%', height: '100%' },
  productName: {
    whiteSpace: 'normal',
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 2,
    wordBreak: 'break-word',
    overflow: 'hidden',
    webkitLineClamp: 1,
    width: '80%',
  },
  tableContainer: ({ isCompact }) => ({ width: isCompact ? '100%' : '50%' }),
  input: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey['300']}`,
    borderTopWidth: 0,
    borderRadius: '4px',
    textAlign: 'center',
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
  },
  removeButton: {
    fill: theme.palette.grey['500'],
    '&:hover': {
      fill: theme.palette.common.black,
    },
    '&:active': {
      fill: theme.palette.error.main,
    },
  },
  subsidyRow: {
    color: theme.palette.warning.main,
  },
  totalPrice: {
    color: theme.palette.primary.dark,
  },
  borderTop: {
    borderTopWidth: '0.2px',
  },
}));
